import React from 'react';

const BrandSettingsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default BrandSettingsPage;
